import { connect } from 'react-redux';
import { addEvent, clearRoute, importRoute, editEvent, eventFilterSet, removeEvent, requestPlaceOptions, requestTour,requestProposals} from '../modules/tour';

import TourRouteTab from './TourRouteTab';

const mapDispatchToProps = {
  clearRoute,
  importRoute,
  addEvent,
  removeEvent,
  editEvent,
  requestPlaceOptions,
  eventFilterSet,
  requestTour,
  requestProposals,
};

const mapStateToProps = state => ({
  tour: state.tours.selectedTour.tour,
  proposals: state.tours.selectedTour.proposals,
  places: state.tours.places,
  filter: state.tours.selectedTour.eventFilter,
});
const TourRouteTabContainer = connect(
    mapStateToProps,
    mapDispatchToProps)(TourRouteTab);
export default TourRouteTabContainer;



// WEBPACK FOOTER //
// src/routes/tours/components/TourRouteTabContainer.js